/*
 *
 * @desc: GTM事件分发统计
 *
 *        应用：GTM-PXB757S  china.store.insta360
 *        ===  {{GA}}：UA-79598165-17 - Store.China
 *        ===  {{GA_Cross}}：UA-79598165-22 - Main.China
 *
 *        应用：GTM-N8S5S4B  oversea.store.insta360
 *        ===  {{GA}}：UA-79598165-18 Store.Oversea
 *        ===  {{GA_Cross}}：UA-79598165-21 Main.Oversea ******
 *
 */
import { isDebug } from '@/utils';

class Tracker {
  /**
   *
   * @description 普通事件推送，需要声明event事件名
   * @param data {Object} 事件对象
   * @param data.event {String} 事件名（最大100字符）
   * @param data.category {String} 事件类别（最大100字符）
   * @param data.action {String} 事件操作（最大100字符）
   * @param data.label {String} 事件标签（最大100字符）
   * @param data.value {String} 事件值（最大100字符）
   */
  DataLayerEventPush = (params) => {
    const data = {
      event: params?.event || 'not set event',
      category: params.category || '',
      action: params.action || '',
      label: params.label || '',
      value: params.value || 1,
    };
    window.dataLayer?.push?.(data);
    if (isDebug()) {
      console.log('-----埋点数据 DataLayerEventPush-----');
      console.log(data);
    }
  };

  /**
   * @description 普通事件推送，需要声明event事件名
   * @param data {Object} 事件对象
   * @param [data.event] {String} 事件名（最大100字符）
   * @param data.category {String} 事件类别（最大100字符）
   * @param data.action {String} 事件操作（最大100字符）
   * @param data.label {String} 事件标签（最大100字符）
   * @param [data.value] {String} 事件值（最大100字符）
   */
  commonTracker = ({ category, action = '', label = '', value = 1 }) => {
    if (typeof window === 'undefined') return;
    const data = {
      event: 'CommonTracker',
      category,
      action,
      label,
      value: value || 1,
    };
    window.dataLayer?.push?.(data);
    if (isDebug()) {
      console.log('-----埋点数据 common tracker-----');
      console.log(data);
    }
  };

  /**
   *
   * @description 电子商务功能
   * @param event 事件名
   * @param event_from 区分ua/ga4
   * @param ecommerce 电子商务数据
   *
   */
  commonEcommerceTracker = ({ event, event_from = 'UA', ecommerce = {} }) => {
    if (typeof window === 'undefined') return;
    // Clear the previous ecommerce object.
    window.dataLayer?.push?.({ ecommerce: null });
    const data = {
      event,
      event_from,
      ecommerce,
    };
    window.dataLayer?.push?.(data);
    if (isDebug()) {
      console.log('-----埋点数据 电子商务事件 ecommerce tracker-----');
      console.log(data);
    }
  };
}

export default Tracker;
